import { NavLink, useNavigate } from "react-router-dom";
import { richiediUscita } from "@/components/UnsavedBar";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import {
  CalendarCheck, Flame, Building2, Users, UserSquare, Footprints, FileText, Trophy, Crown,
  DollarSign, LogOut, Menu, X, ShieldCheck, CalendarDays, Kanban, Bell, Clock, Check, History,
  CheckSquare, FileSignature, FileCheck2, Wallet, UserCircle, MonitorSmartphone, ClipboardCheck, LifeBuoy, ShieldAlert, FolderOpen, ChevronDown, Trash2, Gauge, Camera, Receipt, GraduationCap, Presentation, Send, Plus, MessageCircle, Eye,
} from "lucide-react";
import { useState, useEffect, useRef } from "react";
import { toast } from "sonner";
import { Logo, BrandIcon } from "@/components/Logo";
import QuickFab from "@/components/QuickFab";
import BackBar from "@/components/BackBar";
import { NuovaVersione } from "@/components/NuovaVersione";
import { BarraSalvato } from "@/components/SalvataggioUI";
import { PannelloCaricamenti } from "@/components/PannelloCaricamenti";

const NAV = [
  { to: "/oggi", label: "Home", icon: CalendarCheck, testid: "nav-home" },
  { to: "/task", label: "Task", icon: CheckSquare, testid: "nav-task" },
  { to: "/immobili", label: "Immobili", icon: Building2, testid: "nav-immobili" },
  { to: "/proprietari", label: "Venditori", icon: UserSquare, testid: "nav-venditori" },
  { to: "/acquirenti", label: "Acquirenti", icon: Users, testid: "nav-acquirenti" },
  { to: "/proposte", label: "Proposte in corso", icon: FileText, testid: "nav-proposte" },
  { to: "/preliminari", label: "Preliminari", icon: FileSignature, testid: "nav-preliminari" },
  { to: "/rogiti", label: "Vendite", icon: FileCheck2, testid: "nav-vendite" },
  { to: "/agenda", label: "Agenda", icon: CalendarDays, testid: "nav-agenda" },
  { to: "/riunioni", label: "Riunioni", icon: Presentation, testid: "nav-riunioni" },
  { to: "/documenti", label: "Documenti", icon: FolderOpen, testid: "nav-documenti" },
  { to: "/archivio-documenti", label: "Archivio documenti", icon: FolderOpen, testid: "nav-archivio-documenti" },
  { to: "/classifica", label: "Obiettivi e classifiche", icon: Trophy, testid: "nav-classifica" },
  { to: "/obiettivi-team", label: "Obiettivi team", icon: Trophy, testid: "nav-obiettivi-team" },
  { to: "/albo-oro", label: "Albo d'oro", icon: Crown, testid: "nav-albo-oro" },
  { to: "/formazione", label: "Start Academy", icon: GraduationCap, testid: "nav-formazione" },
  { to: "/marketing", label: "Reparto marketing", icon: Camera, testid: "nav-marketing" },
];

const MSG_NAV = { to: "/messaggi", label: "Messaggi", icon: MessageCircle, testid: "nav-messaggi" };
const FOTO_NAV = [
  { to: "/marketing", label: "Reparto marketing", icon: Camera, testid: "nav-fotografo-servizi" },
  { to: "/fatture", label: "Le mie fatture", icon: Receipt, testid: "nav-fotografo-fatture" },
  { to: "/riunioni", label: "Riunioni", icon: Presentation, testid: "nav-riunioni" },
  { to: "/formazione", label: "Start Academy", icon: GraduationCap, testid: "nav-formazione" },
];
const AGENT_NAV = [
  { to: "/oggi", label: "Home", icon: CalendarCheck, testid: "nav-home" },
  { to: "/task", label: "Task", icon: CheckSquare, testid: "nav-task" },
  { to: "/notizie", label: "Notizie", icon: Flame, testid: "nav-notizie" },
  { to: "/immobili", label: "Immobili", icon: Building2, testid: "nav-immobili" },
  { to: "/proprietari", label: "Clienti venditori", icon: UserSquare, testid: "nav-venditori" },
  { to: "/acquirenti", label: "Clienti acquirenti", icon: Users, testid: "nav-acquirenti" },
  { to: "/visite", label: "Visite e feedback", icon: Footprints, testid: "nav-visite" },
  { to: "/proposte", label: "Proposte e trattative", icon: FileText, testid: "nav-proposte" },
  { to: "/preliminari", label: "Preliminari", icon: FileSignature, testid: "nav-preliminari" },
  { to: "/rogiti", label: "Vendite", icon: FileCheck2, testid: "nav-vendite" },
  { to: "/agenda", label: "Agenda", icon: CalendarDays, testid: "nav-agenda" },
  { to: "/riunioni", label: "Riunioni", icon: Presentation, testid: "nav-riunioni" },
  { to: "/documenti", label: "Documenti", icon: FolderOpen, testid: "nav-documenti" },
  { to: "/archivio-documenti", label: "Archivio documenti", icon: FolderOpen, testid: "nav-archivio-documenti" },
  { to: "/classifica", label: "Obiettivi", icon: Trophy, testid: "nav-classifica" },
  { to: "/albo-oro", label: "Albo d'oro", icon: Crown, testid: "nav-albo-oro" },
  { to: "/fine-giornata", label: "Fine giornata", icon: History, testid: "nav-fine-giornata" },
  { to: "/formazione", label: "Start Academy", icon: GraduationCap, testid: "nav-formazione" },
  { to: "/marketing", label: "Reparto marketing", icon: Camera, testid: "nav-marketing" },
];

const ROLE_LABEL = {
  direzione: "Direzione",
  direttore_commerciale: "Direttore Commerciale",
  agente: "Agente",
  segreteria: "Segreteria",
};

function fmtWhen(iso) {
  try { return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" }); }
  catch { return ""; }
}

function NotificheBell() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [altre, setAltre] = useState(false);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => api.get("/notifiche?limit=50").then((r) => {
    setUnread(r.data.non_lette);
    setItems((cur) => {
      const nuove = r.data.items;
      const ids = new Set(nuove.map((x) => x.id));
      const vecchie = cur.length > 50 ? cur.filter((x) => !ids.has(x.id) && (x.created_at || "") <= (nuove.at(-1)?.created_at || "")) : [];
      if (!vecchie.length) setAltre(r.data.altre);
      return [...nuove, ...vecchie];
    });
  }).catch(() => {});
  const loadMore = () => api.get(`/notifiche?skip=${items.length}&limit=50`).then((r) => {
    setItems((cur) => { const ids = new Set(cur.map((x) => x.id)); return [...cur, ...r.data.items.filter((x) => !ids.has(x.id))]; });
    setAltre(r.data.altre); setUnread(r.data.non_lette);
  }).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => { clearInterval(t); document.removeEventListener("mousedown", onClick); };
  }, []);


  const openItem = async (n) => {
    if (!n.letta) { await api.put(`/notifiche/${n.id}/letta`); setItems((a) => a.map((x) => x.id === n.id ? { ...x, letta: true } : x)); setUnread((u) => Math.max(0, u - 1)); }
    setOpen(false);
    richiediUscita(() => vaiNotifica(n));
  };
  const vaiNotifica = (n) => {
    if (typeof n.link === "string" && n.link.startsWith("/") && n.link !== "/" && n.link !== "/oggi") nav(n.link);
    else if (n.tipo === "approvazione") nav("/da-approvare");
    else if (n.tipo === "task") nav("/task");
    else if (n.tipo === "ticket") nav("/ticket");
    else if (n.tipo === "vendita" || n.tipo === "utente" || n.tipo === "immobile") nav(n.link || "/rogiti");
    else if (n.tipo === "riunione") nav(n.link || "/riunioni");
    else if (n.tipo === "azione" || n.tipo === "notizia") nav(n.link || "/task");
    else nav("/agenda");
  };
  const readAll = async () => { await api.put("/notifiche/letta-tutte"); setItems((a) => a.map((x) => ({ ...x, letta: true }))); setUnread(0); };
  const [selN, setSelN] = useState(() => new Set());
  const togN = (id) => setSelN((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const leggiSel = async () => {
    const ids = [...selN].filter((id) => !items.find((x) => x.id === id)?.letta);
    const r = await Promise.allSettled(ids.map((id) => api.put(`/notifiche/${id}/letta`)));
    const ok = r.filter((x) => x.status === "fulfilled").length;
    setItems((a) => a.map((x) => (selN.has(x.id) ? { ...x, letta: true } : x))); setUnread((u) => Math.max(0, u - ok)); setSelN(new Set());
    toast.success(`${ok} segnate come lette${r.length - ok ? `, ${r.length - ok} saltate` : ""}`);
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notifiche-bell" onClick={() => setOpen((o) => !o)}
              className="relative p-2 rounded-lg hover:bg-slate-100 text-[var(--muted)] hover:text-[#111111] transition-colors">
        <Bell size={18} />
        {unread > 0 && <span data-testid="notifiche-badge" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-[#FC82ED] text-black text-[10px] font-bold flex items-center justify-center">{unread}</span>}
      </button>
      {open && (
        <div data-testid="notifiche-dropdown" className="absolute right-0 mt-2 w-80 max-h-[70vh] overflow-y-auto card-immo p-0 z-50 shadow-xl">
          <div className="flex items-center justify-between p-3 border-b border-[var(--border)] sticky top-0 bg-[#F7F7F8]">
            <span className="font-display font-bold text-sm">{selN.size ? `${selN.size} selezionate` : "Promemoria"}</span>
            {selN.size > 0 ? <span className="flex items-center gap-2"><button data-testid="notifiche-sel-lette" onClick={leggiSel} className="text-[11px] text-[#FC82ED] font-semibold">Segna lette</button><button data-testid="notifiche-sel-annulla" onClick={() => setSelN(new Set())} className="text-[11px] text-slate-500">Annulla</button></span>
            : unread > 0 && <button data-testid="notifiche-read-all" onClick={readAll} className="text-[11px] text-[#FC82ED] font-medium flex items-center gap-1"><Check size={12}/> Segna tutte come lette</button>}
          </div>
          {items.length === 0 ? <div className="p-6 text-center text-xs text-[var(--muted)]">Nessun promemoria.</div> :
          <div className="divide-y divide-[var(--border)]">
            {items.map((n) => (
              <button key={n.id} data-testid={`notifica-${n.id}`} onClick={() => (selN.size ? togN(n.id) : openItem(n))}
                      className={`w-full text-left p-3 hover:bg-slate-50 transition-colors flex gap-3 ${selN.has(n.id) ? "bg-[#FC82ED]/15" : !n.letta ? "bg-[#FC82ED]/[0.06]" : ""}`}>
                <span role="checkbox" aria-checked={selN.has(n.id)} data-testid={`notifica-sel-${n.id}`} onClick={(e) => { e.stopPropagation(); togN(n.id); }} className={`mt-2 w-4 h-4 rounded border-2 shrink-0 ${selN.has(n.id) ? "bg-[#FC82ED] border-[#FC82ED]" : "border-slate-300"}`} />
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${!n.letta ? "bg-[#FC82ED]/15 text-[#FC82ED]" : "bg-slate-100 text-[var(--muted)]"}`}><Clock size={15} /></div>
                <div className="min-w-0">
                  <div className={`text-sm truncate ${!n.letta ? "font-bold" : "font-medium text-slate-600"}`}>{n.titolo}</div>
                  {["vendita", "utente", "immobile"].includes(n.tipo) && n.testo && <div data-testid={`notifica-testo-${n.id}`} className="text-xs text-slate-600">{n.testo}</div>}
                  {n.data_evento && <div className="text-[11px] text-[var(--muted)]">{fmtWhen(n.data_evento)}</div>}
                </div>
                {!n.letta && <span className="ml-auto w-2 h-2 rounded-full bg-[#FC82ED] shrink-0 mt-1.5" />}
              </button>
            ))}
            {altre && <button data-testid="notifiche-mostra-altre" onClick={loadMore} className="w-full p-3 text-xs font-semibold text-[#B8369F] hover:bg-slate-50">Mostra altre</button>}
          </div>}
        </div>
      )}
    </div>
  );
}

export default function Layout({ children }) {
  const { user, canFinance, isDirezione, isDirettore, isAgente, isSegreteria, isFotografo, canManageUsers, vista, soloTeam } = useAuth();
  const vistaKey = isDirezione ? `${vista}-${soloTeam ? 1 : 0}` : "std";
  const [open, setOpen] = useState(false);
  const [ciScaduti, setCiScaduti] = useState(0);
  const [taskBadge, setTaskBadge] = useState(0);
  const [checklistCount, setChecklistCount] = useState(0);
  const [ticketBadge, setTicketBadge] = useState(0);
  const [richiesteBadge, setRichiesteBadge] = useState(0);
  const [approvaBadge, setApprovaBadge] = useState(0);
  const [msgBadge, setMsgBadge] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const load = () => {
      if (isFotografo) return;
      api.get("/messaggi/non-letti").then((r) => setMsgBadge(r.data?.non_letti || 0)).catch(() => {});
      api.get("/dashboard/documenti-identita-scadenza")
        .then((r) => setCiScaduti((r.data?.scaduti || []).length)).catch(() => {});
      api.get("/attivita/badge")
        .then((r) => setTaskBadge(r.data?.badge || 0)).catch(() => {});
      if (isSegreteria) api.get("/checklist-queue")
        .then((r) => setChecklistCount((r.data || []).filter((x) => x.stato !== "approvata").length)).catch(() => {});
      api.get("/tickets/badge")
        .then((r) => setTicketBadge(user?.role === "segreteria" ? (r.data?.coda || 0) : (r.data?.aperti || 0))).catch(() => {});
      api.get("/agenda/richieste", { params: { box: "ricevute" } })
        .then((r) => setRichiesteBadge(r.data?.pending_ricevute || 0)).catch(() => {});
      if (isDirezione || isDirettore) {
        Promise.all([
          api.get("/team/approvazioni").catch(() => ({ data: {} })),
          api.get("/sconti/approvazioni").catch(() => ({ data: [] })),
        ]).then(([p, s]) => setApprovaBadge((p.data?.prezzi?.length || 0) + (s.data?.length || 0))).catch(() => {});
      }
    };
    load();
    const t = setInterval(load, 60000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    const onMsg = () => { if (!isFotografo) api.get("/messaggi/non-letti").then((r) => setMsgBadge(r.data?.non_letti || 0)).catch(() => {}); };
    window.addEventListener("messaggi-letti", onMsg);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); window.removeEventListener("messaggi-letti", onMsg); };
  }, []);

  useEffect(() => {
    if (!("setAppBadge" in navigator)) return;
    if (richiesteBadge > 0) navigator.setAppBadge(richiesteBadge).catch(() => {});
    else if ("clearAppBadge" in navigator) navigator.clearAppBadge().catch(() => {});
  }, [richiesteBadge]);

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium mb-1 transition-all ${
      isActive ? "bg-[#FC82ED] text-black font-semibold glow-pink" : "text-slate-600 hover:bg-slate-100 hover:text-[#111111]"
    }`;

  const NavItems = () => (
    <>
      <div className="mb-6">
        {(isFotografo ? FOTO_NAV : isAgente ? AGENT_NAV : (isDirezione || isSegreteria) ? [...NAV.slice(0, 2), ...(isSegreteria ? [] : [AGENT_NAV[2]]), ...NAV.slice(2), { to: "/dati-da-sistemare", label: "Dati da sistemare", icon: ShieldAlert, testid: "nav-dati-da-sistemare" }] : NAV).filter((it) => !(isSegreteria && it.to === "/obiettivi-team")).flatMap((it) => (it.to === "/task" && !isFotografo ? [it, MSG_NAV] : [it])).map((it) => (
          <NavLink
            key={it.testid}
            to={it.to}
            data-testid={it.testid}
            onClick={() => setOpen(false)}
            className={linkCls}
          >
            <it.icon size={18} />
            {it.label}
            {it.to === "/messaggi" && msgBadge > 0 && <span data-testid="nav-messaggi-badge" className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-[#FC82ED] text-[#2B2B2B] text-[10px] font-bold flex items-center justify-center">{msgBadge}</span>}
            {it.to === "/oggi" && ciScaduti > 0 && (
              <span
                data-testid="nav-home-ci-badge"
                title={`${ciScaduti} document${ciScaduti === 1 ? "o" : "i"} d'identità scadut${ciScaduti === 1 ? "o" : "i"}`}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(false); navigate("/oggi?focus=ci"); }}
                className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center cursor-pointer"
              >
                {ciScaduti}
              </span>
            )}
            {it.to === "/task" && taskBadge > 0 && (
              <span
                data-testid="nav-task-scadute-badge"
                title={`${taskBadge} task da gestire (oggi + scaduti)`}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(false); navigate("/task"); }}
                className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center cursor-pointer"
              >
                {taskBadge}
              </span>
            )}
            {it.to === "/agenda" && richiesteBadge > 0 && (
              <span
                data-testid="nav-agenda-richieste-badge"
                title={`${richiesteBadge} richiest${richiesteBadge === 1 ? "a" : "e"} di appuntamento in attesa`}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(false); navigate("/agenda?view=richieste"); }}
                className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center cursor-pointer"
              >
                {richiesteBadge}
              </span>
            )}
          </NavLink>
        ))}
        {!isDirezione && !isFotografo && (
          <NavLink to="/le-mie-richieste" data-testid="nav-le-mie-richieste" onClick={() => setOpen(false)} className={linkCls}>
            <FileText size={18} /> Le mie richieste
          </NavLink>
        )}
        {(isDirezione || isDirettore || isSegreteria) && (
          <NavLink to="/da-approvare" data-testid="nav-da-approvare" onClick={() => setOpen(false)} className={linkCls}>
            <Check size={18} />
            Da approvare
            {approvaBadge > 0 && (
              <span data-testid="nav-da-approvare-badge" className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">{approvaBadge}</span>
            )}
          </NavLink>
        )}
        {!isAgente && canFinance && (
          <NavLink to="/finanza" data-testid="nav-finanza" onClick={() => setOpen(false)} className={linkCls}>
            <DollarSign size={18} />
            Finanza Aziendale
          </NavLink>
        )}
        {(isDirezione || isSegreteria) && (
          <NavLink to="/qualita-portafoglio" data-testid="nav-qualita-portafoglio" onClick={() => setOpen(false)} className={linkCls}>
            <Gauge size={18} />
            Qualità portafoglio
          </NavLink>
        )}
        {(isDirezione || isSegreteria) && (
          <NavLink to="/direzione-provvigioni" data-testid="nav-direzione-provvigioni" onClick={() => setOpen(false)} className={linkCls}>
            <Wallet size={18} />
            Provvigioni & Quote
          </NavLink>
        )}
        {isDirettore && (
          <NavLink to="/provvigioni-team" data-testid="nav-provvigioni-team" onClick={() => setOpen(false)} className={linkCls}>
            <Wallet size={18} />
            Provvigioni Team
          </NavLink>
        )}
        {user?.role !== "segreteria" && !isFotografo && (
          <NavLink to="/ticket" data-testid="nav-ticket" onClick={() => setOpen(false)} className={linkCls}>
            <LifeBuoy size={18} />
            Ticket Segreteria
            {ticketBadge > 0 && (
              <span data-testid="nav-ticket-badge" title={`${ticketBadge} ticket apert${ticketBadge === 1 ? "o" : "i"}`}
                    className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-[#FC82ED] text-black text-[10px] font-bold flex items-center justify-center">{ticketBadge}</span>
            )}
          </NavLink>
        )}
      </div>
      {!isAgente && (isDirezione || canManageUsers || isSegreteria) && (
        <div className="mb-6">
          <div className="px-3 mb-2 text-[10px] font-bold uppercase tracking-[0.18em] text-[var(--muted)]">AMMINISTRAZIONE</div>
          {isSegreteria && (
            <NavLink to="/coda-checklist" data-testid="nav-coda-checklist" onClick={() => setOpen(false)} className={linkCls}>
              <ClipboardCheck size={18} />
              Coda checklist
              {checklistCount > 0 && (
                <span data-testid="nav-checklist-count" title={`${checklistCount} document${checklistCount === 1 ? "o" : "i"} da verificare`}
                      className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-[#FC82ED] text-black text-[10px] font-bold flex items-center justify-center">
                  {checklistCount}
                </span>
              )}
            </NavLink>
          )}
          {user?.role === "segreteria" && (
            <NavLink to="/ticket" data-testid="nav-coda-ticket" onClick={() => setOpen(false)} className={linkCls}>
              <LifeBuoy size={18} />
              Coda Ticket
              {ticketBadge > 0 && (
                <span data-testid="nav-coda-ticket-count" title={`${ticketBadge} ticket in coda`}
                      className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-[#FC82ED] text-black text-[10px] font-bold flex items-center justify-center">{ticketBadge}</span>
              )}
            </NavLink>
          )}
          {canManageUsers && (
            <NavLink to="/utenti" data-testid="nav-utenti" onClick={() => setOpen(false)} className={linkCls}>
              <Users size={18} />
              Utenti & Team
            </NavLink>
          )}
          <NavLink to="/fine-giornata" data-testid="nav-fine-giornata" onClick={() => setOpen(false)} className={linkCls}>
            <History size={18} />
            Fine giornata
          </NavLink>
          {isDirezione && (
            <NavLink to="/storico" data-testid="nav-storico" onClick={() => setOpen(false)} className={linkCls}>
              <History size={18} />
              Storico Modifiche
            </NavLink>
          )}
          {(isDirezione || isSegreteria) && (
            <NavLink to="/privacy" data-testid="nav-privacy" onClick={() => setOpen(false)} className={linkCls}>
              <ShieldAlert size={18} />
              Privacy & GDPR
            </NavLink>
          )}
          {(isDirezione || isSegreteria) && (
            <NavLink to="/guardiana" data-testid="nav-guardiana" onClick={() => setOpen(false)} className={linkCls}>
              <ShieldCheck size={18} />
              Guardiana dati
            </NavLink>
          )}
          {isDirezione && (
            <NavLink to="/sessioni" data-testid="nav-sessioni" onClick={() => setOpen(false)} className={linkCls}>
              <MonitorSmartphone size={18} />
              Sessioni attive
            </NavLink>
          )}
          {isDirezione && (
            <NavLink to="/pulizia-dati" data-testid="nav-pulizia-dati" onClick={() => setOpen(false)} className={linkCls}>
              <Trash2 size={18} />
              Pulizia dati di prova
            </NavLink>
          )}
          {isDirezione && (
            <NavLink to="/modelli-documenti" data-testid="nav-modelli-documenti" onClick={() => setOpen(false)} className={linkCls}>
              <FileText size={18} />
              Modelli documenti
            </NavLink>
          )}
        </div>
      )}
    </>
  );

  return (
    <div className="min-h-screen flex bg-white">
      <aside className="hidden lg:flex flex-col w-64 shrink-0 border-r border-[var(--border)] bg-[#F7F7F8] p-4 sticky top-0 h-screen">
        <div className="mb-8 mt-2 px-3">
          <Logo width={188} data-testid="sidebar-logo" />
          <div className="text-[10px] text-[var(--muted)] tracking-[0.2em] uppercase mt-2">Sistema Operativo</div>
        </div>
        <nav className="flex-1 overflow-y-auto">
          <NavItems />
        </nav>
      </aside>

      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <aside className="absolute left-0 top-0 h-full w-72 bg-white border-r border-[var(--border)] p-4 overflow-y-auto">
            <div className="flex items-start justify-between mb-8 mt-2 px-1">
              <div>
                <Logo width={180} />
                <div className="text-[10px] text-[var(--muted)] tracking-[0.2em] uppercase mt-2">Sistema Operativo</div>
              </div>
              <button onClick={() => setOpen(false)} data-testid="close-menu"><X size={22} /></button>
            </div>
            <NavItems />
          </aside>
        </div>
      )}

      <div className="flex-1 flex flex-col min-w-0">
        <div className="sticky top-0 z-40">
        <header className="flex items-center justify-between gap-4 px-4 lg:px-8 h-16 border-b border-[var(--border)] bg-white/85 backdrop-blur-xl">
          <div className="flex items-center gap-3 min-w-0">
            <button className="lg:hidden" onClick={() => setOpen(true)} data-testid="open-menu"><Menu size={22} /></button>
            <button onClick={() => navigate("/oggi")} className="lg:hidden shrink-0" aria-label="IMMOBILART"><BrandIcon size={28} /></button>
            <BackBar />
          </div>
          <div className="flex items-center gap-2 sm:gap-3">
            <VistaSocio />
            <ViewSwitcher />
            <NotificheBell />
            <ProfileMenu />
          </div>
        </header>
        <BarraMonitoraggio />
        </div>
        <main key={vistaKey} className="flex-1 p-4 lg:p-8 max-w-[1400px] w-full mx-auto overflow-x-hidden"><NuovaVersione /><BarraSalvato /><PannelloCaricamenti />{children}</main>
      </div>
      {isAgente && <QuickFab />}
    </div>
  );
}


function VistaSocio() {
  const { user, isSocio, isDirezione, haTeam, vista, setVista, switchView } = useAuth();
  const socioDir = isSocio && (user?.roles || []).includes("direttore_commerciale");
  useEffect(() => { if (socioDir && !isDirezione) { switchView("direzione"); } }, [socioDir, isDirezione]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!isDirezione) return null;
  const team = user?.team_name || "Team";
  const opts = [["mia", "La mia attività", "La mia"], ...(haTeam ? [["team", `Il mio team (${team})`, "Team"]] : []), ["ufficio", "Monitoraggio ufficio", "Ufficio"]];
  const cur = vista === "team" && !haTeam ? "ufficio" : vista;
  return (
    <div data-testid="vista-socio-toggle" className="flex rounded-xl border border-[var(--border)] bg-[#F7F7F8] p-0.5 text-xs font-semibold">
      {opts.map(([k, l, s]) => {
        const sel = cur === k;
        return (
          <button key={k} data-testid={`vista-socio-${k}`} aria-pressed={sel} onClick={() => setVista(k)}
                  className={`whitespace-nowrap px-2 sm:px-2.5 py-1.5 rounded-lg transition-colors ${sel ? "bg-[#111111] text-white" : "text-[var(--muted)] hover:text-[#111111]"}`}>
            <span className="sm:hidden">{s}</span><span className="hidden sm:inline">{l}</span>
          </button>
        );
      })}
    </div>
  );
}


function BarraMonitoraggio() {
  const { user, monitoraggio, soloTeam, haTeam } = useAuth();
  if (!monitoraggio) return null;
  const team = user?.team_name || "Team";
  return (
    <div data-testid="barra-monitoraggio" className="flex items-center justify-between gap-3 px-4 lg:px-8 py-1.5 bg-[#111111] text-white text-xs">
      <span className="flex items-center gap-1.5 min-w-0"><Eye size={13} className="text-[#FC82ED] shrink-0" />
        <span className="truncate">{haTeam && soloTeam ? `Stai vedendo il team ${team}` : "Stai vedendo tutto l'ufficio"}</span></span>
    </div>
  );
}


function ViewSwitcher() {
  const { user, switchView } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const views = user?.available_views || [];
  const roles = user?.roles || [];
  if (views.length < 2 || roles.includes("direzione")) return null;
  const current = views.find((v) => v.key === user?.active_view) || views[0];
  const pick = async (v) => {
    setOpen(false);
    if (v.key === user?.active_view) return;
    setBusy(true);
    try { await switchView(v.key); navigate("/oggi"); } finally { setBusy(false); }
  };
  return (
    <div className="relative" ref={ref}>
      <button data-testid="view-switcher-trigger" onClick={() => setOpen((o) => !o)} disabled={busy}
              className="flex items-center gap-1.5 rounded-xl border border-[#FC82ED]/40 bg-[#FC82ED]/10 px-2.5 py-1.5 text-xs font-semibold text-[#111111] hover:bg-[#FC82ED]/20 transition-colors disabled:opacity-60">
        <span className="hidden sm:inline text-[var(--muted)] font-medium">Vista:</span>
        <span className="max-w-[120px] truncate">{current?.label}</span>
        <ChevronDown size={14} className="text-[#FC82ED]" />
      </button>
      {open && (
        <div data-testid="view-switcher-menu" className="absolute right-0 mt-2 w-56 card-immo p-1.5 z-50 shadow-xl">
          {views.map((v) => {
            const sel = v.key === user?.active_view;
            return (
              <button key={v.key} data-testid={`view-opt-${v.key}`} onClick={() => pick(v)}
                      className={`w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${sel ? "bg-[#FC82ED]/15 text-[#111111] font-semibold" : "text-[#111111] hover:bg-slate-100"}`}>
                <span className="truncate">Vista {v.label}</span>
                {sel && <Check size={15} className="text-[#FC82ED]" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}


function ProfileMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div className="relative" ref={ref}>
      <button data-testid="profile-menu-trigger" onClick={() => setOpen((v) => !v)} aria-label="Menu profilo"
              className="flex items-center gap-2 sm:gap-3 rounded-lg hover:bg-slate-100 px-1.5 py-1 transition-colors">
        <div className="text-right hidden sm:block">
          <div className="text-sm font-semibold leading-tight" data-testid="topbar-user-name">{user?.name}</div>
          <div className="text-[11px] text-[#FC82ED] font-medium">{ROLE_LABEL[user?.role]}{user?.team_name ? ` · ${user.team_name}` : ""}</div>
        </div>
        {user?.avatar ? (
          <img src={user.avatar} alt="" className="w-9 h-9 rounded-full object-cover border border-[var(--border)]" />
        ) : (
          <div className="w-9 h-9 rounded-full bg-[#FC82ED]/15 border border-[#FC82ED]/40 flex items-center justify-center text-[#FC82ED] font-bold text-sm">
            {user?.name?.slice(0, 1)}
          </div>
        )}
      </button>
      {open && (
        <div data-testid="profile-menu" className="absolute right-0 mt-2 w-52 card-immo p-1.5 z-50 shadow-xl">
          <button data-testid="profile-menu-link" onClick={() => { setOpen(false); navigate("/profilo"); }}
                  className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-[#111111] hover:bg-slate-100 transition-colors">
            <UserCircle size={16} className="text-[#FC82ED]" /> Il mio profilo
          </button>
          <button data-testid="logout-btn" onClick={logout}
                  className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-[#111111] hover:bg-slate-100 transition-colors">
            <LogOut size={16} className="text-[var(--muted)]" /> Esci
          </button>
        </div>
      )}
    </div>
  );
}
